<template>
  <div>
    <h2 class="text__colour-teal text__align-center">
      Create your account
    </h2>

    <div
      class="layout__padding-clear layout__position-center text__align-center layout__padding__top-20px layout__break-word text__align-center"
    >
      <!--      <span-->
      <!--        v-html="titleText"-->
      <!--      />-->
      <p>
        If you need help completing this form, please contact us on <br>
        <span class="text__colour-teal">{{ supportPhone }}</span> or
        <a
          :href="`mailto:${supportEmail}`"
          class="text__colour-teal-important"
        >
          {{ supportEmail }}
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegistrationTitle',

  props: {
    accountType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      supportEmail: 'orders@printconcern.co.uk',
      supportPhone: '01865 712211',
    };
  },

  computed: {
    title() {
      return this.accountType === 'ACCOUNT' ? 'Credit' : 'pay-as-you-go';
    },

    titleText() {
      switch (this.accountType) {
        case 'ACCOUNT':
          return 'Subject to standard credit checks, credit accounts can take up to 48 hours to set up. <br> You will be notified via email when your account is active and ready to use. <br> Want to set up a pay-as-you-go account to pay via credit or debit card? Click back to select Credit account.<br><br>'

        case 'PAYG':
          return 'Want to set up a credit account for monthly invoices? Click back to select Credit account.<br><br>';

        default:
          return '';
      }
    },
  },
};
</script>